<template>
  <i-switch
    :value="String(info.defaultValue)"
    :true-value="info.form.trueValue||'true'"
    :false-value="info.form.falseValue||'false'"
    :disabled="info.form.disabled||!info.isNew"
    :size="size"
    @input="(val) => info.defaultValue = val">
    <span slot="open">{{info.form.open}}</span>
    <span slot="close">{{info.form.close}}</span>
  </i-switch>
</template>
<script>
import { baseComponentMixins } from '../mixins'

export default {
  name: 'BaseSwitch',
  mixins: [ baseComponentMixins ],
}
</script>